import Icon from 'components/ui/Icon/Icon';

import { ReactComponent as Spinner } from '../../assets/icons/spinner.svg';

export const SpinnerInline = () => (
  <div className="flex flex-col items-center justify-center h-full">
    <Icon
      svg={Spinner}
      size={70}
    />
    <p>Loading</p>
  </div>
);
